import { generateClient, isCancelError, post } from "aws-amplify/api";

const client = generateClient();

export async function requestListBusinessInvitation(dispatch, payload) {
  try {
    const {
      page,
      limit = 5,
      sortDirection = "DESC",
      status,
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_BUSINESS_INVITATION",
      payload: { request: null, page },
    });
    const params = {
      status,
      limit,
      sortDirection,
      nextToken,
    };

    const request = client.graphql({
      query: businessInvitesByStatusCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_BUSINESS_INVITATION",
      payload: { request, page },
    });

    const res = await request;

    const { items, nextToken: token } =
      res.data.businessInvitesByStatusCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "SUCCESS_LIST_BUSINESS_INVITATION",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CANCEL_LIST_BUSINESS_INVITATION",
      });
    } else {
      dispatch({ type: "ERROR_LIST_BUSINESS_INVITATION", error });
    }
  }
}

export async function requestCreateBusinessInvitation(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_INVITATION",
      payload: { request: null },
    });
    const { input, expired_at } = payload;

    if (expired_at) {
      input.expired_at = expired_at;
    }

    const request = post({
      apiName: "business",
      path: "/invite",
      options: {
        body: input,
      },
    });

    dispatch({
      type: "REQUEST_CREATE_BUSINESS_INVITATION",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();
    const businessInvite = res.data;

    dispatch({
      type: "CREATE_BUSINESS_INVITATION_SUCCESS",
      payload: {
        businessInvite,
      },
    });
  } catch (error) {
    dispatch({
      type: "CREATE_BUSINESS_INVITATION_ERROR",
      error,
    });
  }
}

export async function requestActionBusinessInvitation(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_ACTION_BUSINESS_INVITATION",
      payload: { request: null },
    });
    const { invite_id, action } = payload;

    const request = post({
      apiName: "business",
      path: "/inviteAction",
      options: {
        body: {
          invite_id,
          action,
        },
      },
    });

    dispatch({
      type: "REQUEST_ACTION_BUSINESS_INVITATION",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    const actionBusinessInvite = res.data;

    dispatch({
      type: "ACTION_BUSINESS_INVITATION_SUCCESS",
      payload: {
        actionBusinessInvite,
      },
    });
  } catch (error) {
    dispatch({
      type: "ACTION_BUSINESS_INVITATION_ERROR",
      error,
    });
  }
}

export async function clearBusinessInvitation(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_INVITATION" });
}

export async function clearBusinessInvitationError(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_INVITATION_ERROR" });
}

export async function clearActionBusinessInvitation(dispatch) {
  dispatch({ type: "CLEAR_ACTION_BUSINESS_INVITATION" });
}

const businessInvitesByStatusCreatedAt = /* GraphQL */ `
  query BusinessInvitesByStatusCreatedAt(
    $status: InviteStatus
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessInviteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessInvitesByStatusCreatedAt(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        businessID
        currentBusinessName
        expiredAt
        codeExpiredAt
        createdAt
        owner
        receiver
        userID
        user {
          id
          name
        }
        receiverUserID
        receiverUser {
          id
          name
        }
        updatedAt
      }
      nextToken
    }
  }
`;
